<template>
	<div>
		<div class="az_overview_tb_bx">
			<table class="az_overview_tb">
				<thead>
				<tr>
					<td>{{$t('menu.project')}} </td>
					<td>{{$t('repoerts.numberBoards')}}</td>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td>
						<div class="d-flex align-items-center">
							<div class="az_ovw_color mr-3" style="background:#64D0DA;"></div>{{$t('TOTALPROJECTS')}}
						</div>
					</td>
					<td>{{ projectData.projectCount }}</td>
				</tr>
				<tr>
					<td>
						<div class="d-flex align-items-center">
							<div class="az_ovw_color mr-3" style="background:#877BEB;"></div> {{$t('ACTIVEPROJECTS')}}
						</div>
					</td>
					<td>{{ projectData.activeProjects }}</td>
				</tr>
				<tr>
					<td>
						<div class="d-flex align-items-center">
							<div class="az_ovw_color mr-3" style="background:#EA4A66;"></div>  {{$t('SUCCESSFULPROJECTS')}}
						</div>
					</td>
					<td>{{ projectData.successProjects }}</td>
				</tr>
				<tr style="color:#ff0000;">
					<td>
						<div class="d-flex align-items-center">
							<div class="az_ovw_color mr-3" style="background:#FE7297;"></div>{{$t('EXPIREDPROJECTS')}}
						</div>
					</td>
					<td>{{ projectData.expiredProjects }}</td>
				</tr>
				</tbody>
			</table>
		</div>


		<div class="az_overview_chart_kan" v-if="series.length > 0">
			<vue-apex-charts type="pie" width="100%" :options="chartOptions" :series="series"/>
		</div>
	</div>
</template>

<script>
	import VueApexCharts from 'vue-apexcharts'


	export default {
		name: "TypeKanbanOverall",
		components: {
			VueApexCharts,
		},
		data:() => ({
			projectData: {},
			projectDataTotal: 0,
			series: [],
			chartOptions: {
				colors:['#64D0DA', '#877BEB', '#EA4A66', '#FE7297', '#FFC65B'],
				legend: {
					show: false,
				},
			}
		}),
		created() {
			this.GetProjectAll();
		},
		methods: {
			async GetProjectAll() {
				const {data: {data}} = await this.$api.get('report/project-task-count')
        this.projectData = data
			},
		}
	}
</script>